export default __webpack_public_path__ + "static/media/GEQ.21dad246.svg";